export enum U21AiChatBubbleType {
  MULTISELECT = 'multiselect',
}

export const MAX_AI_CHAT_CHOICES = 5;

export interface U21AiChatBubbleInnerProps {
  choices: string[];
  disabled?: boolean;
}

export interface U21AiChatMultiSelectInnerProps extends U21AiChatBubbleInnerProps {
  initialValues?: string[];
  onChange: (answer: string[]) => void;
}
